"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/servicesSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSectionServicesLinkSixteenActivesItem = {
    key: Key | null | undefined;
    /** Detected variants: "services-link-sixteen active" | "services-link-sixteen" */
    className: string;
    /** Detected variants: "#tab1" | "#tab2" | "#tab3" | "#tab4" | "#tab5" */
    dataBsTarget: string;
    /** Detected variants: "Weight Management" | "Personalized Nutrition Plans" | "Healthy Lifestyle Coaching" | "Group Wellness Programs" | "Dietitian Consultations" */
    h30Text: ReactNode;
    /** Detected variants: "[01]" | "[02]" | "[03]" | "[04]" | "[05]" */
    span0Text: ReactNode;
    /** Detected variants: "Evidence based approaches to sustainable weight loss or gain on long term lifestyle transformation." | "Custom-tailored meal strategies designed around your unique goals, lifestyle, and dietary preferences." | "Guidance that integrates nutrition, movement, sleep, and stress management." | "Collaborative group sessions and challenges focused on shared health goals and community support." | "One on one sessions with certified dietitians who understand your health history and personal challenges." */
    p0Text: ReactNode;
    /** Detected variants: "tab" */
    dataBsToggle?: string;
    /** Detected variants: "title" */
    h30ClassName?: string;
    /** Detected variants: "serial" */
    span0ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};

type ServicesSectionTabPaneFadeShowActivesItem = {
    key: Key | null | undefined;
    /** Detected variants: "tab-pane fade show active" | "tab-pane fade" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/service/service-img-5.jpg" | "/Templates/Doccure/img/service/service-img-6.jpg" | "/Templates/Doccure/img/service/service-img-7.jpg" | "/Templates/Doccure/img/service/service-img-8.jpg" | "/Templates/Doccure/img/service/service-img-9.jpg" */
    src: string;
    /** Detected variants: "tab1" | "tab2" | "tab3" | "tab4" | "tab5" */
    id: string;
    /** Detected variants: "services-item-sixteen" */
    div0ClassName?: string;
    /** Detected variants: "services-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "service-img" */
    alt?: string;
    /** Detected variants: "img-fluid service-img" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "View Details" */
    ariaLabel?: string;
    /** Detected variants: "services-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    servicesContentItems?: ServicesSectionDescriptionsItem[];
};

type ServicesSectionDescriptionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Weight loss strategies" | "Muscle gain plans" | "Metabolic health" | "Lifestyle adjustment" | "Behavioral changes" | "Custom meal planning" | "Dietary assessment" | "Macro tracking" | "Nutrient optimization" | "Recipe suggestions" | "Lifestyle optimization" | "Energy enhancement" | "Stress reduction" | "Sleep improvement" | "Habit formation" | "Group discussions" | "Shared challenges" | "Peer motivation" | "Expert guidance" | "Interactive workshops" | "Detailed consultation" | "Health history review" | "Goal definition" | "Expert feedback" | "Progress monitoring" */
    pText: ReactNode;
    /** Detected variants: "description" */
    className?: string;
    /** Detected variants: "isax isax-play-circle5" */
    i0ClassName?: string;
};
export type HomeSixteenServicesSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionTabPaneFadeShowActivesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionTabPaneFadeShowActivesItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H40H4Props?: Partial<ComponentProps<"h4">> | ((item: ServicesSectionTabPaneFadeShowActivesItem) => Partial<ComponentProps<"h4">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionServicesLinkSixteenActivesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our Services" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Our programs designed to meet you" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "exactly where you are" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "shadow" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/services-shadow-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/services-shadow-2.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    servicesSectionServicesLinkSixteenActives: ServicesSectionServicesLinkSixteenActivesItem[];
    servicesSectionTabPaneFadeShowActives: ServicesSectionTabPaneFadeShowActivesItem[];
    servicesSectionServicesLinkSixteenActivesItemWrapper?: (item: ServicesSectionServicesLinkSixteenActivesItem, content: ReactNode) => ReactNode;
    servicesSectionServicesLinkSixteenActivesRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesLinkSixteenActivesH3Visible?: boolean;
    servicesSectionServicesLinkSixteenActivesH3Renderer?: (item: ServicesSectionServicesLinkSixteenActivesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesLinkSixteenActivesH3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionServicesLinkSixteenActivesItem) => Partial<ComponentProps<"h3">>);
    servicesSectionTabPaneFadeShowActivesItemWrapper?: (item: ServicesSectionTabPaneFadeShowActivesItem, content: ReactNode) => ReactNode;
    servicesSectionTabPaneFadeShowActivesRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionTabPaneFadeShowActivesLinkVisible?: boolean;
    servicesSectionTabPaneFadeShowActivesLinkRenderer?: (item: ServicesSectionTabPaneFadeShowActivesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionTabPaneFadeShowActivesImageVisible?: boolean;
    servicesSectionTabPaneFadeShowActivesImageRenderer?: (item: ServicesSectionTabPaneFadeShowActivesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionTabPaneFadeShowActivesH4Visible?: boolean;
    servicesSectionTabPaneFadeShowActivesH4Renderer?: (item: ServicesSectionTabPaneFadeShowActivesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionTabPaneFadeShowActivesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionTabPaneFadeShowActivesItem) => Partial<ComponentProps<typeof SmartLink>>);
    servicesSectionTabPaneFadeShowActivesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionTabPaneFadeShowActivesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    servicesSectionTabPaneFadeShowActivesH4Props?: Partial<ComponentProps<"h4">> | ((item: ServicesSectionTabPaneFadeShowActivesItem) => Partial<ComponentProps<"h4">>);
    servicesSectionDescriptionsItemWrapper?: (item: ServicesSectionDescriptionsItem, content: ReactNode) => ReactNode;
    servicesSectionDescriptionsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSixteenServicesSectionGenerated: FC<HomeSixteenServicesSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Services",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Our programs designed to meet you",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "exactly where you are",
    sectionDiv0Div1Div0Div0DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "shadow",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/services-shadow-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "shadow",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/services-shadow-2.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H40H4Props,
    divH30H3Props,
    sectionDiv0Div1ClassName,
    servicesSectionServicesLinkSixteenActives,
    servicesSectionTabPaneFadeShowActives,
    servicesSectionServicesLinkSixteenActivesItemWrapper,
    servicesSectionServicesLinkSixteenActivesRenderer,
    servicesSectionServicesLinkSixteenActivesH3Visible,
    servicesSectionServicesLinkSixteenActivesH3Renderer,
    servicesSectionServicesLinkSixteenActivesH3Props,
    servicesSectionTabPaneFadeShowActivesItemWrapper,
    servicesSectionTabPaneFadeShowActivesRenderer,
    servicesSectionTabPaneFadeShowActivesLinkVisible,
    servicesSectionTabPaneFadeShowActivesLinkRenderer,
    servicesSectionTabPaneFadeShowActivesImageVisible,
    servicesSectionTabPaneFadeShowActivesImageRenderer,
    servicesSectionTabPaneFadeShowActivesH4Visible,
    servicesSectionTabPaneFadeShowActivesH4Renderer,
    servicesSectionTabPaneFadeShowActivesLinkProps,
    servicesSectionTabPaneFadeShowActivesImageProps,
    servicesSectionTabPaneFadeShowActivesH4Props,
    servicesSectionDescriptionsItemWrapper,
    servicesSectionDescriptionsRenderer,
}) => {
    return (
        <section className="section services-section-sixteen">
            <div className="container">
                <div className="section-header-sixteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            {" "}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center row-gap-4"}>
                    <div className="col-xl-8 col-lg-7">
                        <div className="services-nav-sixteen wow fadeInDown" data-wow-duration={sectionDiv0Div1Div0Div0DivDataWowDuration} role="tablist">
                            {renderCollectionNode(
                                servicesSectionServicesLinkSixteenActives,
                                (item: ServicesSectionServicesLinkSixteenActivesItem) => (
                                    <div className={item.className} data-bs-toggle={item.dataBsToggle ?? "tab"} data-bs-target={item.dataBsTarget} key={item.key}>
                                        {renderItemNode(servicesSectionServicesLinkSixteenActivesH3Visible, servicesSectionServicesLinkSixteenActivesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "title"} {...(typeof servicesSectionServicesLinkSixteenActivesH3Props === "function" ? servicesSectionServicesLinkSixteenActivesH3Props(item) : (servicesSectionServicesLinkSixteenActivesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                {item.h30Text}
                                                <span className={item.span0ClassName ?? "serial"}>{item.span0Text}</span>
                                                {" "}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                ),
                                servicesSectionServicesLinkSixteenActivesItemWrapper,
                                servicesSectionServicesLinkSixteenActivesRenderer
                            )}
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-5">
                        <div className="tab-content">
                            {renderCollectionNode(
                                servicesSectionTabPaneFadeShowActives,
                                (item: ServicesSectionTabPaneFadeShowActivesItem) => (
                                    <div className={item.className} id={item.id} key={item.key}>
                                        <div className={item.div0ClassName ?? "services-item-sixteen"}>
                                            <div className={item.div0ClassName2 ?? "services-overlay"}>
                                                {renderItemNode(servicesSectionTabPaneFadeShowActivesImageVisible, servicesSectionTabPaneFadeShowActivesImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "service-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid service-img"} {...(typeof servicesSectionTabPaneFadeShowActivesImageProps === "function" ? servicesSectionTabPaneFadeShowActivesImageProps(item) : (servicesSectionTabPaneFadeShowActivesImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                                {renderItemNode(servicesSectionTabPaneFadeShowActivesLinkVisible, servicesSectionTabPaneFadeShowActivesLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "services-icon"} aria-label={item.ariaLabel ?? "View Details"} {...(typeof servicesSectionTabPaneFadeShowActivesLinkProps === "function" ? servicesSectionTabPaneFadeShowActivesLinkProps(item) : (servicesSectionTabPaneFadeShowActivesLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                        <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                                    </SmartLink>
                                                ))}
                                            </div>
                                            <div className="services-content">
                                                {renderItemNode(servicesSectionTabPaneFadeShowActivesH4Visible, servicesSectionTabPaneFadeShowActivesH4Renderer, item, (
                                                    <h4 className="title" {...(typeof servicesSectionTabPaneFadeShowActivesH4Props === "function" ? servicesSectionTabPaneFadeShowActivesH4Props(item) : (servicesSectionTabPaneFadeShowActivesH4Props ?? {}))} {...(typeof divDiv0Div1H40H4Props === "function" ? divDiv0Div1H40H4Props(item) : (divDiv0Div1H40H4Props ?? {}))}>Evidence-based approaches to sustainable weight loss or gain on long-term lifestyle transformation.</h4>
                                                ))}
                                                {renderCollectionNode(
                                                    item.servicesContentItems ?? [],
                                                    (item: ServicesSectionDescriptionsItem) => (
                                                        <p className={item.className ?? "description"} key={item.key}>
                                                            {" "}
                                                            <span>
                                                                <i className={item.i0ClassName ?? "isax isax-play-circle5"} />
                                                            </span>
                                                            {" "}
                                                            {item.pText}
                                                        </p>
                                                    ),
                                                    servicesSectionDescriptionsItemWrapper,
                                                    servicesSectionDescriptionsRenderer
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ),
                                servicesSectionTabPaneFadeShowActivesItemWrapper,
                                servicesSectionTabPaneFadeShowActivesRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one d-none d-lg-block" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-two d-none d-lg-block" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixteenServicesSectionGenerated;
